import { Linkedin, Instagram, Facebook, Youtube, Globe } from 'lucide-react';
import type { SocialPlatform } from '@/lib/social-links';

export const SOCIAL_PLATFORMS: {
  key: SocialPlatform;
  label: string;
  icon: typeof Globe;
  color: string;
}[] = [
  { key: 'linkedin', label: 'LinkedIn', icon: Linkedin, color: '#0A66C2' },
  { key: 'instagram', label: 'Instagram', icon: Instagram, color: '#E1306C' },
  { key: 'facebook', label: 'Facebook', icon: Facebook, color: '#1877F2' },
  { key: 'youtube', label: 'YouTube', icon: Youtube, color: '#FF0000' },
];
